import { TelemetryEntry, TelemetryEntryMetadata, TelemetryEntryValueInterface, TelemetryEntryValueNumber } from "./telemetry.types";

export namespace Decoder {
  export function parseTimestamp(issTimestamp: string): Date {
    let now = new Date();
    let year = new Date(Date.UTC(now.getUTCFullYear(), 0)); // This year, jan 1, 00:00:00, utc
    // THE TELEMETRY TIME SEEMS TO ADD 24 HOURS TO NUMBER
    // OF HOURS IN THE YEAR SO FAR.  STRANGE.  TODO
    // so we subtract 24 from fTimeStamp, convert to seconds
    // add to number of seconds as of THIS_YEAR-01-01T00:00:00 UTC
    // truncate the decimal places for a result in seconds, aka unixtime
    let unixTime = (((parseFloat(issTimestamp) - 24) * 3600) + (year.getTime() / 1000)) | 0
    return new Date(unixTime * 1000);
  }

  export function value(telemetryId: string, value: number, timestamp: string): Array<TelemetryEntry> {
    let entries = new Array<TelemetryEntry>({
      id: telemetryId,
      metadata: metadata(telemetryId),
      value: {
        type: "number",
        value: value
      },
      timestamp: parseTimestamp(timestamp)
    } as TelemetryEntry);

    if (MULTIPLE_VALUES_SEPERATOR.hasOwnProperty(telemetryId)) {
      let values = MULTIPLE_VALUES_SEPERATOR[telemetryId](value);
      entries = values.map((valObj) => {
        let id = Object.keys(valObj)[0];
        let val = Object.values(valObj)[0];
        return {
          id,
          metadata: metadata(id),
          value: {
            type: "number",
            value: val
          }
        } as TelemetryEntry;
      });
    }

    entries = entries.map((entry) => {
      if (VALUE_TO_STRING.hasOwnProperty(entry.id)) {
        entry.value = {
          type: "string",
          value: VALUE_TO_STRING[entry.id][entry.value.value as number]
        };
      } else if (VALUE_CONV_FUNC.hasOwnProperty(entry.id)) {
        entry.value = VALUE_CONV_FUNC[entry.id](entry.value);
      }
      return entry;
    })

    return entries;
  }

  export function metadata(telemetryId: string): TelemetryEntryMetadata {
    return {
      ...METADATA[telemetryId],
      highlight: true
    };
  }

  export function getTelemetryEntries(): Array<string> {
    return Object.keys(METADATA);
  }
}

const METADATA: { [key: string]: TelemetryEntryMetadata } = {
  "AIRLOCK000001": { title: "PSA EMU1 VOLTS", desc: "Supplies power through the Umbilical Interface Assembly (UIA) to the spacesuits (EMU 1), Voltage", class: "EVA pui" },
  "AIRLOCK000002": { title: "PSA EMU1 AMPS", desc: "Supplies power through the Umbilical Interface Assembly (UIA) to the spacesuits (EMU 1), Current", class: "EVA pui" },
  "AIRLOCK000003": { title: "PSA EMU2 VOLTS", desc: "Supplies power through the Umbilical Interface Assembly (UIA) to the spacesuits (EMU 2), Voltage", class: "EVA pui" },
  "AIRLOCK000004": { title: "PSA EMU2 AMPS", desc: "Supplies power through the Umbilical Interface Assembly (UIA) to the spacesuits (EMU 2), Current", class: "EVA pui" },
  "AIRLOCK000005": { title: "PSA IRU VOLTS", desc: "In-flight Refill Unit (IRU), Voltage", class: "EVA pui" },
  "AIRLOCK000006": { title: "PSA IRU AMPS", desc: "In-flight Refill Unit (IRU), Current", class: "EVA pui" },
  "AIRLOCK000007": { title: "UIA EV 1 VOLTS", desc: "Supplies power to the spacesuits (EVA Mobility Unit, EMU 1), Voltage", class: "EVA pui" },
  "AIRLOCK000008": { title: "UIA EV 1 AMPS", desc: "Supplies power to the spacesuits (EVA Mobility Unit, EMU 1), Current", class: "EVA pui" },
  "AIRLOCK000009": { title: "UIA EV 2 VOLTS", desc: "Supplies power to the spacesuits (EVA Mobility Unit, EMU 2), Voltage", class: "EVA pui" },
  "AIRLOCK000010": { title: "UIA EV 2 AMPS", desc: "Supplies power to the spacesuits (EVA Mobility Unit, EMU 2), Current", class: "EVA pui" },
  "AIRLOCK000011": { title: "BCA 1 VOLTS", desc: "Battery Charger Assembly (BCA) 1 Voltage", class: "EVA pui" },
  "AIRLOCK000012": { title: "BCA 1 AMPS", desc: "Battery Charger Assembly (BCA) 1 Current", class: "EVA pui" },
  "AIRLOCK000013": { title: "BCA 2 VOLTS", desc: "Battery Charger Assembly (BCA) 2 Voltage", class: "EVA pui" },
  "AIRLOCK000014": { title: "BCA 2 AMPS", desc: "Battery Charger Assembly (BCA) 2 Current", class: "EVA pui" },
  "AIRLOCK000015": { title: "BCA 3 VOLTS", desc: "Battery Charger Assembly (BCA) 3 Voltage", class: "EVA pui" },
  "AIRLOCK000016": { title: "BCA 3 AMPS", desc: "Battery Charger Assembly (BCA) 3 Current", class: "EVA pui" },
  "AIRLOCK000017": { title: "BCA 4 VOLTS", desc: "Battery Charger Assembly (BCA) 4 Voltage", class: "EVA pui" },
  "AIRLOCK000018": { title: "BCA 4 AMPS", desc: "Battery Charger Assembly (BCA) 4 Current", class: "EVA pui" },
  "AIRLOCK000019": { title: "BCA 1 STATUS", desc: "Battery Charger Assembly (BCA) 1 Status", class: "EVA pui" },
  "AIRLOCK000020": { title: "BCA 2 STATUS", desc: "Battery Charger Assembly (BCA) 2 Status", class: "EVA pui" },
  "AIRLOCK000021": { title: "BCA 3 STATUS", desc: "Battery Charger Assembly (BCA) 3 Status", class: "EVA pui" },
  "AIRLOCK000022": { title: "BCA 4 STATUS", desc: "Battery Charger Assembly (BCA) 4 Status", class: "EVA pui" },
  "AIRLOCK000023": { title: "BCA 1 CH1 STATUS", desc: "Battery Charger Assembly (BCA) 1 Channel 1 Status", class: "EVA pui" },
  "AIRLOCK000024": { title: "BCA 1 CH2 STATUS", desc: "Battery Charger Assembly (BCA) 1 Channel 2 Status", class: "EVA pui" },
  "AIRLOCK000025": { title: "BCA 1 CH3 STATUS", desc: "Battery Charger Assembly (BCA) 1 Channel 3 Status", class: "EVA pui" },
  "AIRLOCK000026": { title: "BCA 1 CH4 STATUS", desc: "Battery Charger Assembly (BCA) 1 Channel 4 Status", class: "EVA pui" },
  "AIRLOCK000027": { title: "BCA 1 CH5 STATUS", desc: "Battery Charger Assembly (BCA) 1 Channel 5 Status", class: "EVA pui" },
  "AIRLOCK000028": { title: "BCA 1 CH6 STATUS", desc: "Battery Charger Assembly (BCA) 1 Channel 6 Status", class: "EVA pui" },
  "AIRLOCK000029": { title: "BCA 2 CH1 STATUS", desc: "Battery Charger Assembly (BCA) 2 Channel 1 Status", class: "EVA pui" },
  "AIRLOCK000030": { title: "BCA 2 CH2 STATUS", desc: "Battery Charger Assembly (BCA) 2 Channel 2 Status", class: "EVA pui" },
  "AIRLOCK000031": { title: "BCA 2 CH3 STATUS", desc: "Battery Charger Assembly (BCA) 2 Channel 3 Status", class: "EVA pui" },
  "AIRLOCK000032": { title: "BCA 2 CH4 STATUS", desc: "Battery Charger Assembly (BCA) 2 Channel 4 Status", class: "EVA pui" },
  "AIRLOCK000033": { title: "BCA 2 CH5 STATUS", desc: "Battery Charger Assembly (BCA) 2 Channel 5 Status", class: "EVA pui" },
  "AIRLOCK000034": { title: "BCA 2 CH6 STATUS", desc: "Battery Charger Assembly (BCA) 2 Channel 6 Status", class: "EVA pui" },
  "AIRLOCK000035": { title: "BCA 3 CH1 STATUS", desc: "Battery Charger Assembly (BCA) 3 Channel 1 Status", class: "EVA pui" },
  "AIRLOCK000036": { title: "BCA 3 CH2 STATUS", desc: "Battery Charger Assembly (BCA) 3 Channel 2 Status", class: "EVA pui" },
  "AIRLOCK000037": { title: "BCA 3 CH3 STATUS", desc: "Battery Charger Assembly (BCA) 3 Channel 3 Status", class: "EVA pui" },
  "AIRLOCK000038": { title: "BCA 3 CH4 STATUS", desc: "Battery Charger Assembly (BCA) 3 Channel 4 Status", class: "EVA pui" },
  "AIRLOCK000039": { title: "BCA 3 CH5 STATUS", desc: "Battery Charger Assembly (BCA) 3 Channel 5 Status", class: "EVA pui" },
  "AIRLOCK000040": { title: "BCA 3 CH6 STATUS", desc: "Battery Charger Assembly (BCA) 3 Channel 6 Status", class: "EVA pui" },
  "AIRLOCK000041": { title: "BCA 4 CH1 STATUS", desc: "Battery Charger Assembly (BCA) 4 Channel 1 Status", class: "EVA pui" },
  "AIRLOCK000042": { title: "BCA 4 CH2 STATUS", desc: "Battery Charger Assembly (BCA) 4 Channel 2 Status", class: "EVA pui" },
  "AIRLOCK000043": { title: "BCA 4 CH3 STATUS", desc: "Battery Charger Assembly (BCA) 4 Channel 3 Status", class: "EVA pui" },
  "AIRLOCK000044": { title: "BCA 4 CH4 STATUS", desc: "Battery Charger Assembly (BCA) 4 Channel 4 Status", class: "EVA pui" },
  "AIRLOCK000045": { title: "BCA 4 CH5 STATUS", desc: "Battery Charger Assembly (BCA) 4 Channel 5 Status", class: "EVA pui" },
  "AIRLOCK000046": { title: "BCA 4 CH6 STATUS", desc: "Battery Charger Assembly (BCA) 4 Channel 6 Status", class: "EVA pui" },
  "AIRLOCK000047": { title: "DP VOLT STATUS", desc: "Pumps atmosphere from Airlock into Node one during depress, voltage status.", class: "EVA pui" },
  "AIRLOCK000048": { title: "DP SW STATUS", desc: "Pumps atmosphere from Airlock into Node one during depress, switch status.", class: "EVA pui" },
  "AIRLOCK000049": { title: "CREWLOCK PRESS", desc: "Crewlock Pressure", class: "ETHOS pui" },
  "AIRLOCK000050": { title: "A/L HI P O2 VLV POS", desc: "Hi P O2 Supply valve position", class: "ETHOS pui" },
  "AIRLOCK000051": { title: "A/L LO P O2 VLV POS", desc: "Lo P O2 Supply Valve position", class: "ETHOS pui" },
  "AIRLOCK000052": { title: "A/L N2 VLV POS", desc: "N2 Supply Valve position", class: "ETHOS pui" },
  "AIRLOCK000053": { title: "A/L A/C STATE", desc: "Airlock Air Conditioner State", class: "ETHOS pui" },
  "AIRLOCK000054": { title: "AIRLOCK PRESS", desc: "Airlock Pressure", class: "ETHOS pui" },
  "AIRLOCK000055": { title: "A/L HI P O2 PRESS", desc: "Airlock Hi P O2 Tank Pressure", class: "ETHOS pui" },
  "AIRLOCK000056": { title: "A/L LO P O2 PRESS", desc: "Airlock Lo P O2 Tank Pressure", class: "ETHOS pui" },
  "AIRLOCK000057": { title: "A/L N2 PRESS", desc: "Airlock N2 Tank Pressure", class: "ETHOS pui" },
  "AIRLOCK000058": { title: "A/L MDM STATUS", desc: "Airlock Multiplexer/Demultiplexer (MDM) on-off status", class: "CDH pui" },
  "NODE1000001": { title: "N1 MDM 1 STATUS", desc: "Node 1 Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "NODE1000002": { title: "N1 MDM 2 STATUS", desc: "Node 1 Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "NODE2000001": { title: "N2 MTL H2O QTY", desc: "Coolant water quantity (Node 2), Medium Temperature Loop", class: "ETHOS pui" },
  "NODE2000002": { title: "N2 LTL H2O QTY", desc: "Coolant water quantity (Node 2), Low Temperature Loop", class: "ETHOS pui" },
  "NODE2000003": { title: "N2 A/C STATE", desc: "Node 2 Air Conditioner State", class: "ETHOS pui" },
  "NODE2000004": { title: "N2 MDM 2 STATUS", desc: "Node 2 Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "NODE2000005": { title: "N2 MDM 1 STATUS", desc: "Node 2 Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "NODE2000006": { title: "N2 AIR COOL TEMP", desc: "Node 2 Air Cooling Fluid Temp", class: "ETHOS pui" },
  "NODE2000007": { title: "N2 AV COOL TEMP", desc: "Node 2 Avionics Cooling Fluid Temp", class: "ETHOS pui" },
  "NODE3000001": { title: "N3 PPO2", desc: "Node 3 ppO2", class: "ETHOS pui" },
  "NODE3000002": { title: "N3 PPN2", desc: "Node 3 ppN2", class: "ETHOS pui" },
  "NODE3000003": { title: "N3 PPCO2", desc: "Node 3 ppCO2", class: "ETHOS pui" },
  "NODE3000004": { title: "UPA STATE", desc: "Urine Processor State", class: "ETHOS pui" },
  "NODE3000005": { title: "URINE TANK QTY", desc: "Urine Tank Qty", class: "ETHOS pui" },
  "NODE3000006": { title: "WPA STATE", desc: "Water Processor State", class: "ETHOS pui" },
  "NODE3000007": { title: "WPA PROC STEP", desc: "Water Processor Step", class: "ETHOS pui" },
  "NODE3000008": { title: "WW TANK QTY", desc: "Waste Water Tank Qty", class: "ETHOS pui" },
  "NODE3000009": { title: "CW TANK QTY", desc: "Clean Water Tank Qty", class: "ETHOS pui" },
  "NODE3000010": { title: "OGA STATE", desc: "Oxygen Generator State", class: "ETHOS pui" },
  "NODE3000011": { title: "OGA PROD RATE", desc: "O2 Production rate", class: "ETHOS pui" },
  "NODE3000012": { title: "N3 AV COOL TEMP", desc: "Avionics Cooling Fluid Temp (Node 3)", class: "ETHOS pui" },
  "NODE3000013": { title: "N3 AC COOL TEMP", desc: "Air Cooling Fluid Temp (Node 3)", class: "ETHOS pui" },
  "NODE3000014": { title: "HCZ MDM 2 STATUS", desc: "Hub Control Zone (HCZ) Multiplexer/Demultiplexer 2 (MDM) on-off status", class: "CDH pui" },
  "NODE3000015": { title: "N3 MDM 2 STATUS", desc: "Node 3 Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "NODE3000016": { title: "HCZ MDM 1 STATUS", desc: "Hub Control Zone (HCZ) Multiplexer/Demultiplexer 1 (MDM) on-off status", class: "CDH pui" },
  "NODE3000017": { title: "N3 MTL H2O QTY", desc: "Coolant water quantity (Node 3)", class: "ETHOS pui" },
  "NODE3000018": { title: "N3 A/C STATE", desc: "Node 3 Air Conditioner State", class: "ETHOS pui" },
  "NODE3000019": { title: "N3 LTL H2O QTY", desc: "Coolant water quantity (Node 3)", class: "ETHOS pui" },
  "NODE3000020": { title: "N3 MDM 1 STATUS", desc: "Node 3 Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "P1000001": { title: "LP B PM FLOWRATE", desc: "Loop B Pump Flowrate (kg/hr)", class: "SPARTAN pui" },
  "P1000002": { title: "LP B PM OUT PRESS", desc: "Loop B PM Out Press (kPa)", class: "SPARTAN pui" },
  "P1000003": { title: "LP B PM OUT TEMP", desc: "Loop B PM Out Temp (deg C)", class: "SPARTAN pui" },
  "P1000004": { title: "SASA 2 AZ", desc: "S-Band Radio Frequency Group (RFG 2) Azimuth Gimbal Position", class: "CATO pui" },
  "P1000005": { title: "SASA 2 EL", desc: "S-Band Radio Frequency Group (RFG 2) Elevation Gimbal Position", class: "CATO pui" },
  "P1000006": { title: "P1 MDM 1 STATUS", desc: "P1 Truss Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "P1000007": { title: "SASA 2 STATUS", desc: "S-Band Radio Frequency Group (RFG 2), on-off status", class: "CATO pui" },
  "P1000008": { title: "PTR MDM STATUS", desc: "Port Thermal Radiator (PTR) Multiplexer/Demultiplexer (MDM) on-off status", class: "CDH pui" },
  "P1000009": { title: "P1 MDM 2 STATUS", desc: "P1 Truss Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "P3000001": { title: "P3 MDM 1 STATUS", desc: "P3 Truss Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "P3000002": { title: "P3 MDM 2 STATUS", desc: "P3 Truss Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "P4000001": { title: "PVCU 2A VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2A - Drive Voltage", class: "SPARTAN pui" },
  "P4000002": { title: "PVCU 2A AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2A - Drive Current", class: "SPARTAN pui" },
  "P4000003": { title: "PVCU 2A MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2A Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "P4000004": { title: "PVCU 4A VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4A - Drive Voltage", class: "SPARTAN pui" },
  "P4000005": { title: "PVCU 4A AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4A - Drive Current", class: "SPARTAN pui" },
  "P4000006": { title: "PVCU 4A MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4A Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "P4000007": { title: "PVCU 2A BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2A - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "P4000008": { title: "PVCU 4A BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4A - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "P6000001": { title: "PVCU 4B VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4B - Drive Voltage", class: "SPARTAN pui" },
  "P6000002": { title: "PVCU 4B AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4B - Drive Current", class: "SPARTAN pui" },
  "P6000003": { title: "PVCU 4B MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4B Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "P6000004": { title: "PVCU 2B VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2B - Drive Voltage", class: "SPARTAN pui" },
  "P6000005": { title: "PVCU 2B AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2B - Drive Current", class: "SPARTAN pui" },
  "P6000006": { title: "PVCU 2B MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2B Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "P6000007": { title: "PVCU 4B BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 4B - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "P6000008": { title: "PVCU 2B BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 2B - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "RUSSEG000001": { title: "RS SM MODE", desc: "Russian Segment Station Mode - Service Module (SM)", class: "VVO pui" },
  "RUSSEG000002": { title: "KURS 1 OPER", desc: "First Kurs Equipment Kit Operating", class: "VVO pui" },
  "RUSSEG000003": { title: "KURS 2 OPER", desc: "Second Kurs Equipment Kit Operating", class: "VVO pui" },
  "RUSSEG000004": { title: "RS SM KURS FAIL", desc: "Service Module Kurs P1, P2 Failure - Russian Segment", class: "VVO pui" },
  "RUSSEG000005": { title: "SM KURS RANGE", desc: "Distance from Service Module (SM) Kurs (Range)", class: "VVO pui" },
  "RUSSEG000006": { title: "SM KURS RATE", desc: "Rate from Service Module (SM) Kurs (Range Rate)", class: "VVO pui" },
  "RUSSEG000007": { title: "SM KURS TEST", desc: "Service Module (SM) Kurs-P Test Mode - Russian Segment", class: "VVO pui" },
  "RUSSEG000008": { title: "SM KURS CAPTURE", desc: "Service Module (SM) Kurs-P 'Capture' Signal Availability", class: "VVO pui" },
  "RUSSEG000009": { title: "SM KURS TGT ACQ", desc: "Service Module (SM) Kurs-P Target Acquisition Signal - Russian Segment", class: "VVO pui" },
  "RUSSEG000010": { title: "SM KURS MODE", desc: "Service Module (SM) Kurs-P Functional Mode Signal - Russian Segment", class: "VVO pui" },
  "RUSSEG000011": { title: "SM KURS STBY", desc: "Service Module (SM) Kurs-P Standby Mode - Russian Segment", class: "VVO pui" },
  "RUSSEG000012": { title: "SM DOCKING", desc: "Service Module Docking Flag", class: "VVO pui" },
  "RUSSEG000013": { title: "SM FWD DOCK ENG", desc: "Service Module (SM) Forward Docking Port Engaged", class: "VVO pui" },
  "RUSSEG000014": { title: "SM AFT DOCK ENG", desc: "Service Module (SM) Aft Docking Port Engaged", class: "VVO pui" },
  "RUSSEG000015": { title: "SM NAD DOCK ENG", desc: "Service Module (SM) Nadir (Down-looking) Docking Port Engaged - Along Y-Axis", class: "VVO pui" },
  "RUSSEG000016": { title: "FGB NAD DOCK ENG", desc: "Functional Cargo Block (FGB) Nadir (Down-looking) Docking Port Engaged - Along Y-Axis", class: "VVO pui" },
  "RUSSEG000017": { title: "SM NAD UDM ENG", desc: "Service Module (SM) Nadir (Down-looking) Universal Docking Module (UDM) Docking Port Engaged - Along Y-Axis", class: "VVO pui" },
  "RUSSEG000018": { title: "MRM 1 DOCK ENGA", desc: "Mini Research Module (MRM) 1 Docking Port Engaged - Russian Segment", class: "VVO pui" },
  "RUSSEG000019": { title: "MRM 2 DOCK ENGA", desc: "Mini Research Module (MRM) 2 Docking Port Engaged - Russian Segment", class: "VVO pui" },
  "RUSSEG000020": { title: "SM DOCK HKS CLSD", desc: "Service Module - Docked Vehicle Hooks Closed - Russian Segment", class: "VVO pui" },
  "RUSSEG000021": { title: "RS GNC ATT MODE", desc: "Service Module - Russian Guidance, Navigation, and Control - Active Attitude Mode - Russian Segment", class: "VVO pui" },
  "RUSSEG000022": { title: "RS GNC CONTROL", desc: "Service Module - Russian Guidance, Navigation, and Control - Motion Control - Russian Segment", class: "VVO pui" },
  "RUSSEG000023": { title: "RS GNC FR DFT", desc: "Service Module - Russian Guidance, Navigation, and Control - Prepared to Free Drift Mode Transition - Russian Segment", class: "VVO pui" },
  "RUSSEG000024": { title: "RS GNC TSTR TERM", desc: "Service Module - Russian Guidance, Navigation, and Control - Thruster Operation Mode Terminated - Russian Segment", class: "VVO pui" },
  "RUSSEG000025": { title: "RS GNC DYN MODE", desc: "Service Module - Russian Guidance, Navigation, and Control - Current Dynamic Mode - Russian Segment", class: "ADCO-VVO pui" },
  "S0000001": { title: "STBD TRRJ POS", desc: "Starboard Thermal Radiator Rotating Joint (TRRJ) Position (degrees)", class: "SPARTAN-VVO pui" },
  "S0000002": { title: "PORT TRRJ POS", desc: "Port Thermal Radiator Rotating Joint (TRRJ) Position (degrees)", class: "SPARTAN-VVO pui" },
  "S0000003": { title: "STBD SARJ POS", desc: "Solar Alpha Rotary Joint (SARJ) Starboard Joint Angle Position (degrees)", class: "SPARTAN-VVO pui" },
  "S0000004": { title: "PORT SARJ POS", desc: "Solar Alpha Rotary Joint (SARJ) Port Joint Angle Position (degrees)", class: "SPARTAN-VVO pui" },
  "S0000005": { title: "PT SARJ CMD POS", desc: "Solar Alpha Rotary Joint (SARJ) Port Joint Angle Commanded Position (degrees)", class: "VVO pui" },
  "S0000006": { title: "TRRJ LP B MODE", desc: "External Thermal Control System (ETCS) - Thermal Radiator Rotating Joint (TRRJ) - Loop B - Software mode", class: "VVO pui" },
  "S0000007": { title: "TRRJ LP A MODE", desc: "External Thermal Control System (ETCS) - Thermal Radiator Rotating Joint (TRRJ) - Loop A - Software mode", class: "VVO pui" },
  "S0000008": { title: "PORT SARJ MODE", desc: "External Primary Solar Alpha Rotary Joint (SARJ) Port Mode", class: "VVO pui" },
  "S0000009": { title: "STBD SARJ MODE", desc: "External Primary Solar Alpha Rotary Joint (SARJ) Starboard Mode", class: "VVO pui" },
  "S0000010": { title: "ECZ MDM 1 STATUS", desc: "External Control Zone Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "S0000011": { title: "S0 MDM 1 STATUS", desc: "S0 Truss Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "S0000012": { title: "ECZ MDM 2 STATUS", desc: "External Control Zone Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "S0000013": { title: "S0 MDM 2 STATUS", desc: "S0 Truss Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "S1000001": { title: "LP A PM FLOWRATE", desc: "Loop A Pump Flowrate (kg/hr)", class: "SPARTAN pui" },
  "S1000002": { title: "LP A PM OUT PRESS", desc: "Loop A PM Out Press (kPa)", class: "SPARTAN pui" },
  "S1000003": { title: "LP A PM OUT TEMP", desc: "Loop A PM Out Temp (deg C)", class: "SPARTAN pui" },
  "S1000004": { title: "SASA 1 AZ", desc: "S-Band Radio Frequency Group (RFG 1) Azimuth Gimbal Position", class: "CATO pui" },
  "S1000005": { title: "SASA 1 EL", desc: "S-Band Radio Frequency Group (RFG 1) Elevation Gimbal Position", class: "CATO-VVO pui" },
  "S1000006": { title: "STR MDM STATUS", desc: "Starboard Thermal Radiator (STR) Multiplexer/Demultiplexer (MDM) on-off status", class: "CDH pui" },
  "S1000007": { title: "S1 MDM 1 STATUS", desc: "S1 Truss Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "S1000008": { title: "S1 MDM 2 STATUS", desc: "S1 Truss Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "S1000009": { title: "SASA 1 STATUS", desc: "S-Band Radio Frequency Group (RFG 1), on-off status", class: "CATO pui" },
  "S3000001": { title: "S3 MDM 1 STATUS", desc: "S3 Truss Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "S3000002": { title: "S2 MDM 2 STATUS", desc: "S3 Truss Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "S4000001": { title: "PVCU 1A VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1A - Drive Voltage", class: "SPARTAN pui" },
  "S4000002": { title: "PVCU 1A AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1A - Drive Current", class: "SPARTAN pui" },
  "S4000003": { title: "PVCU 1A MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1A Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "S4000004": { title: "PVCU 3A VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3A - Drive Voltage", class: "SPARTAN pui" },
  "S4000005": { title: "PVCU 3A AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3A - Drive Current", class: "SPARTAN pui" },
  "S4000006": { title: "PVCU 3A MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3A Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "S4000007": { title: "PVCU 1A BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1A - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "S4000008": { title: "PVCU 2A BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3A - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "S6000001": { title: "PVCU 3B VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3B - Drive Voltage", class: "SPARTAN pui" },
  "S6000002": { title: "PVCU 3B AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3B - Drive Current", class: "SPARTAN pui" },
  "S6000003": { title: "PVCU 3B MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3B Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "S6000004": { title: "PVCU 1B VOLTS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1B - Drive Voltage", class: "SPARTAN pui" },
  "S6000005": { title: "PVCU 1B AMPS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1B - Drive Current", class: "SPARTAN pui" },
  "S6000006": { title: "PVCU 1B MDM STAT", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1B Multiplexer/Demultiplexer (MDM) 120 Volt On-Off Status", class: "CDH pui" },
  "S6000007": { title: "PVCU 3B BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 3B - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "S6000008": { title: "PVCU 1B BGA POS", desc: "Photovolatic Control Unit (PVCU) - Solar Array - 1B - Beta Gimble Assembly (BGA) Position (degrees)", class: "SPARTAN pui" },
  "USLAB000001": { title: "CMG 1 STATUS", desc: "Control Moment Gyroscope (CMG)-1 On-Line", class: "ADCO pui" },
  "USLAB000002": { title: "CMG 2 STATUS", desc: "Control Moment Gyroscope (CMG)-2 On-Line", class: "ADCO pui" },
  "USLAB000003": { title: "CMG 3 STATUS", desc: "Control Moment Gyroscope (CMG)-3 On-Line", class: "ADCO pui" },
  "USLAB000004": { title: "CMG 4 STATUS", desc: "Control Moment Gyroscope (CMG)-4 On-Line", class: "ADCO pui" },
  "USLAB000005": { title: "CMGS ONLINE", desc: "Number of Control Moment Gyroscope (CMG)s Online", class: "ADCO pui" },
  "USLAB000006": { title: "CMG ROLL TORQUE", desc: "Control Moment Gyroscope (CMG) Control Torque - Roll (N-m)", class: "ADCO pui" },
  "USLAB000007": { title: "CMG PITCH TORQUE", desc: "Control Moment Gyroscope (CMG) Control Torque - Pitch (N-m)", class: "ADCO pui" },
  "USLAB000008": { title: "CMG YAW TORQUE", desc: "Control Moment Gyroscope (CMG) Control Torque - Yaw (N-m)", class: "ADCO pui" },
  "USLAB000009": { title: "ACT CMG MOM", desc: "Active Control Moment Gyroscope (CMG) Momentum (Nms)", class: "ADCO pui" },
  "USLAB000010": { title: "CMG MOM PCT", desc: "Control Moment Gyroscope (CMG) Momentum Percentage (%)", class: "ADCO-VVO pui" },
  "USLAB000011": { title: "DESAT REQ", desc: "Desaturation Request (Enabled/Inhibited)", class: "ADCO pui" },
  "USLAB000012": { title: "USOS GNC MODE", desc: "US Guidance, Navigation and Control (GNC) Mode", class: "ADCO-VVO pui" },
  "USLAB000013": { title: "USOS ATT SRC", desc: "US Attitude Source", class: "ADCO pui" },
  "USLAB000014": { title: "USOS RATE SRC", desc: "US Rate Source", class: "ADCO pui" },
  "USLAB000015": { title: "USOS SV SRC", desc: "US State Vector Source", class: "ADCO pui" },
  "USLAB000016": { title: "ATT CTRLR TYP", desc: "Attitude Controller Type", class: "ADCO pui" },
  "USLAB000017": { title: "ATT CTRL REF", desc: "Attitude Control Reference Frame", class: "ADCO pui" },
  "USLAB000018": { title: "LVLH QTRN 0", desc: "US Current Local Vertical Local Horizontal (LVLH) Attitude Quaternion Component 0", class: "ADCO pui" },
  "USLAB000019": { title: "LVLH QTRN 1", desc: "US Current Local Vertical Local Horizontal (LVLH) Attitude Quaternion Component 1", class: "ADCO pui" },
  "USLAB000020": { title: "LVLH QTRN 2", desc: "US Current Local Vertical Local Horizontal (LVLH) Attitude Quaternion Component 2", class: "ADCO pui" },
  "USLAB000021": { title: "LVLH QTRN 3", desc: "US Current Local Vertical Local Horizontal (LVLH) Attitude Quaternion Component 3", class: "ADCO pui" },
  "USLAB000022": { title: "ROLL ERROR", desc: "US Attitude Roll Error (deg)", class: "ADCO pui" },
  "USLAB000023": { title: "PITCH ERROR", desc: "US Attitude Pitch Error (deg)", class: "ADCO pui" },
  "USLAB000024": { title: "YAW ERROR", desc: "US Attitude Yaw Error (deg)", class: "ADCO pui" },
  "USLAB000025": { title: "INERTL ROLL RATE", desc: "US Inertial Attitude Rate X (deg/s)", class: "ADCO pui" },
  "USLAB000026": { title: "INERTL PITCH RATE", desc: "US Inertial Attitude Rate Y (deg/s)", class: "ADCO pui" },
  "USLAB000027": { title: "INERTL YAW RATE", desc: "US Inertial Attitude Rate Z (deg/s)", class: "ADCO pui" },
  "USLAB000028": { title: "CMD QTRN 0", desc: "US Commanded Attitude Quaternion Component 0", class: "ADCO pui" },
  "USLAB000029": { title: "CMD QTRN 1", desc: "US Commanded Attitude Quaternion Component 1", class: "ADCO pui" },
  "USLAB000030": { title: "CMD QTRN 2", desc: "US Commanded Attitude Quaternion Component 2", class: "ADCO pui" },
  "USLAB000031": { title: "CMD QTRN 3", desc: "US Commanded Attitude Quaternion Component 3", class: "ADCO pui" },
  "USLAB000032": { title: "GNC J2K SV RX", desc: "US Guidance, Navigation and Control (GNC) J2000 Propagated State Vector - X (km)", class: "ADCO-TOPO pui" },
  "USLAB000033": { title: "GNC J2K SV RY", desc: "US Guidance, Navigation and Control (GNC) J2000 Propagated State Vector - Y (km)", class: "ADCO-TOPO pui" },
  "USLAB000034": { title: "GNC J2K SV RZ", desc: "US Guidance, Navigation and Control (GNC) J2000 Propagated State Vector - Z (km)", class: "ADCO-TOPO pui" },
  "USLAB000035": { title: "GNC J2K SV VX", desc: "US Guidance, Navigation and Control (GNC) J2000 Propagated State Vector - X (m/s)", class: "ADCO-TOPO pui" },
  "USLAB000036": { title: "GNC J2K SV VY", desc: "US Guidance, Navigation and Control (GNC) J2000 Propagated State Vector - Y (m/s)", class: "ADCO-TOPO pui" },
  "USLAB000037": { title: "GNC J2K SV VZ", desc: "US Guidance, Navigation and Control (GNC) J2000 Propagated State Vector - Z (m/s)", class: "ADCO-TOPO pui" },
  "USLAB000038": { title: "CMG CAPACITY", desc: "Active Control Moment Gyroscope (CMG) Momentum Capacity (Nms)", class: "ADCO pui" },
  "USLAB000039": { title: "ISS TOTAL MASS", desc: "ISS Total Mass (kg)", class: "ADCO pui" },
  "USLAB000040": { title: "SOLAR BETA", desc: "Solar Beta Angle (degrees)", class: "ADCO pui" },
  "USLAB000041": { title: "CMG LOAC ALARM", desc: "Loss of CMG Attitude Control (LOAC) Caution Message In Alarm", class: "ADCO pui" },
  "USLAB000042": { title: "ISS LOAC ALARM", desc: "Loss of ISS Attitude Control (LOAC) Caution Message In Alarm", class: "ADCO pui" },
  "USLAB000043": { title: "GPS 1 STATUS", desc: "Global Positioning System (GPS-1) Ops Status", class: "ADCO pui" },
  "USLAB000044": { title: "GPS 2 STATUS", desc: "Global Positioning System (GPS-2) Ops Status", class: "ADCO pui" },
  "USLAB000045": { title: "CMG 1 MT BG TEMP", desc: "Spin Motor Spin Bearing Temperature - Control Moment Gyroscope (CMG) 1 (deg C)", class: "ADCO pui" },
  "USLAB000046": { title: "CMG 2 MT BG TEMP", desc: "Spin Motor Spin Bearing Temperature - Control Moment Gyroscope (CMG) 2 (deg C)", class: "ADCO pui" },
  "USLAB000047": { title: "CMG 3 MT BG TEMP", desc: "Spin Motor Spin Bearing Temperature - Control Moment Gyroscope (CMG) 3 (deg C)", class: "ADCO pui" },
  "USLAB000048": { title: "CMG 4 MR BG TEMP", desc: "Spin Motor Spin Bearing Temperature - Control Moment Gyroscope (CMG) 4 (deg C)", class: "ADCO pui" },
  "USLAB000049": { title: "CMG 1 RS BG TEMP", desc: "Hall Resolver Spin Bearing Temperature - Control Moment Gyroscope (CMG) 1 (deg C)", class: "ADCO pui" },
  "USLAB000050": { title: "CMG 2 RS BG TEMP", desc: "Hall Resolver Spin Bearing Temperature - Control Moment Gyroscope (CMG) 2 (deg C)", class: "ADCO pui" },
  "USLAB000051": { title: "CMG 3 RS BG TEMP", desc: "Hall Resolver Spin Bearing Temperature - Control Moment Gyroscope (CMG) 3 (deg C)", class: "ADCO pui" },
  "USLAB000052": { title: "CMG 4 RS BG TEMP", desc: "Hall Resolver Spin Bearing Temperature - Control Moment Gyroscope (CMG) 4 (deg C)", class: "ADCO pui" },
  "USLAB000053": { title: "LAB PPO2", desc: "Lab ppO2", class: "ETHOS pui" },
  "USLAB000054": { title: "LAB PPN2", desc: "Lab ppN2", class: "ETHOS pui" },
  "USLAB000055": { title: "LAB PPCO2", desc: "Lab ppCO2", class: "ETHOS pui" },
  "USLAB000056": { title: "LAB LTL H2O QTY", desc: "Coolant water quantity, LT (Lab)", class: "ETHOS pui" },
  "USLAB000057": { title: "LAB MTL H2O QTY", desc: "Coolant water quantity, MT (Lab)", class: "ETHOS pui" },
  "USLAB000058": { title: "LAB PRESS", desc: "Cabin pressure", class: "ETHOS pui" },
  "USLAB000059": { title: "LAB TEMP", desc: "Cabin temperature", class: "ETHOS pui" },
  "USLAB000060": { title: "LAB AV COOL TEMP", desc: "Avionics Cooling Fluid Temp (Lab)", class: "ETHOS pui" },
  "USLAB000061": { title: "LAB AC COOL TEMP", desc: "Air Cooling Fluid Temp (Lab)", class: "ETHOS pui" },
  "USLAB000062": { title: "VRS VLV POS", desc: "Vacuum Resource System Valve Position", class: "ETHOS pui" },
  "USLAB000063": { title: "VES VLV POS", desc: "Vacuum Exhaust System Valve Position", class: "ETHOS pui" },
  "USLAB000064": { title: "LAB PORT A/C STATE", desc: "Lab Port Air Conditioner State", class: "ETHOS pui" },
  "USLAB000065": { title: "LAB STBD A/C STATE", desc: "Lab Starboard Air Conditioner State", class: "ETHOS pui" },
  "USLAB000066": { title: "CC MDM 1 STATUS", desc: "Command and Control (C&C) Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "USLAB000067": { title: "CC MDM 2 STATUS", desc: "Command and Control (C&C) Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "USLAB000068": { title: "CC MDM 3 STATUS", desc: "Command and Control (C&C) Multiplexer/Demultiplexer (MDM) 3 on-off status", class: "CDH pui" },
  "USLAB000069": { title: "ICZ MDM 1 STATUS", desc: "Internal Control Zone Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "USLAB000070": { title: "ICZ MDM 2 STATUS", desc: "Internal Control Zone Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "USLAB000071": { title: "PL MDM 1 STATUS", desc: "Payload (PL) Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "USLAB000072": { title: "PL MDM 2 STATUS", desc: "Payload (PL) Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "USLAB000073": { title: "GNC MDM 1 STATUS", desc: "Guidance, Navigation and Control (GNC) Multiplexer/Demultiplexer 1 on-off status", class: "CDH pui" },
  "USLAB000074": { title: "GNC MDM 2 STATUS", desc: "Guidance, Navigation and Control (GNC) Multiplexer/Demultiplexer 2 on-off status", class: "CDH pui" },
  "USLAB000075": { title: "PMCU 1 MDM 1 STAT", desc: "Power Mangement Controller Unit (PMCU) 1 Multiplexer/Demultiplexer 1 on-off status", class: "CDH pui" },
  "USLAB000076": { title: "PMCU 2 MDM 1 STAT", desc: "Power Mangement Controller Unit (PMCU) 2 Multiplexer/Demultiplexer 1 on-off status", class: "CDH pui" },
  "USLAB000077": { title: "LAB MDM 1 STATUS", desc: "US Lab Multiplexer/Demultiplexer (MDM) 1 on-off status", class: "CDH pui" },
  "USLAB000078": { title: "LAB MDM 2 STATUS", desc: "US Lab Multiplexer/Demultiplexer (MDM) 2 on-off status", class: "CDH pui" },
  "USLAB000079": { title: "LAB MDM 3 STATUS", desc: "US Lab Multiplexer/Demultiplexer (MDM) 3 on-off status", class: "CDH pui" },
  "USLAB000080": { title: "PMM SYS PWR STAT", desc: "Permanent Multipurpose Module - System Power voltage status", class: "CDH pui" },
  "USLAB000081": { title: "ATT MNVR IN PROG", desc: "Attitude Maneuver In Progress status", class: "VVO pui" },
  "USLAB000082": { title: "SCC COUNT", desc: "Standard Command Counter - Count of standard commands received by the ISS Command and Control Computer", class: "ODIN pui" },
  "USLAB000083": { title: "DLCC COUNT", desc: "Data Load Command Counter - Count of data load commands received by the ISS Command and Control Computer", class: "ODIN pui" },
  "USLAB000084": { title: "ISS TIME", desc: "ISS Command and Control Multiplexer/Demultiplexer Onboard Time (course)", class: "ODIN pui" },
  "USLAB000086": { title: "STATION MODE", desc: "ISS Station Mode", class: "ODIN-VVO pui" },
  "USLAB000087": { title: "LAPTOPS CONN", desc: "# Laptops active and connected to the Primary Command and Control (C&C) Multiplexer/Demultiplexer (MDM)", class: "ODIN pui" },
  "USLAB000088": { title: "KU VID 1 ACT", desc: "Ku-Band Video Downlink Channel 1 Activity", class: "CATO pui" },
  "USLAB000089": { title: "KU VID 2 ACT", desc: "Ku-Band Video Downlink Channel 2 Activity", class: "CATO pui" },
  "USLAB000090": { title: "KU VID 3 ACT", desc: "Ku-Band Video Downlink Channel 3 Activity", class: "CATO pui" },
  "USLAB000091": { title: "KU VID 4 ACT", desc: "Ku-Band Video Downlink Channel 4 Activity", class: "CATO pui" },
  "USLAB000092": { title: "SBAND STRING", desc: "Active String of S-Band", class: "CATO pui" },
  "USLAB000093": { title: "IAC 1 STATUS", desc: "Internal Audio Controller (IAC) - IAC-1 Active/Backup Indication", class: "CATO pui" },
  "USLAB000094": { title: "IAC 2 STATUS", desc: "Internal Audio Controller (IAC) - IAC-2 Active/Backup Indication", class: "CATO pui" },
  "USLAB000095": { title: "DL 1 SRC", desc: "Video Source Routed to Downlink 1", class: "CATO pui" },
  "USLAB000096": { title: "DL 2 SRC", desc: "Video Source Routed to Downlink 2", class: "CATO pui" },
  "USLAB000097": { title: "DL 3 SRC", desc: "Video Source Routed to Downlink 3", class: "CATO pui" },
  "USLAB000098": { title: "DL 4 SRC", desc: "Video Source Routed to Downlink 4", class: "CATO pui" },
  "USLAB000099": { title: "UHF 1 PWR", desc: "Space-To-Space Radio (UHF) 1 Power", class: "CATO pui" },
  "USLAB000100": { title: "UHF 2 PWR", desc: "Space-To-Space Radio (UHF) 2 Power", class: "CATO pui" },
  "USLAB000101": { title: "UHF FRAME SYNC", desc: "Space-To-Space Radio Frame Sync Lock", class: "CATO pui" },
  "USLAB000102": { title: "SV TIME TAG", desc: "State vector time tag", class: "TOPO pui" },
  "Z1000001": { title: "CMG 1 VIB", desc: "Control Moment Gyroscope (CMG)-1 Vibration (g)", class: "ADCO pui" },
  "Z1000002": { title: "CMG 2 VIB", desc: "Control Moment Gyroscope (CMG)-2 Vibration (g)", class: "ADCO pui" },
  "Z1000003": { title: "CMG 3 VIBE", desc: "Control Moment Gyroscope (CMG)-3 Vibration (g)", class: "ADCO pui" },
  "Z1000004": { title: "CMG 4 VIBE", desc: "Control Moment Gyroscope (CMG)-4 Vibration (g)", class: "ADCO pui" },
  "Z1000005": { title: "CMG 1 MTR AMPS", desc: "Control Moment Gyroscope (CMG)-1 Spin Motor Current (amps)", class: "ADCO pui" },
  "Z1000006": { title: "CMG 2 MTR AMPS", desc: "Control Moment Gyroscope (CMG)-2 Spin Motor Current (amps)", class: "ADCO pui" },
  "Z1000007": { title: "CMG 3 MTR AMPS", desc: "Control Moment Gyroscope (CMG)-3 Spin Motor Current (amps)", class: "ADCO pui" },
  "Z1000008": { title: "CMG 4 MTR AMPS", desc: "Control Moment Gyroscope (CMG)-4 Spin Motor Current (amps)", class: "ADCO pui" },
  "Z1000009": { title: "CMG 1 RPM", desc: "Control Moment Gyroscope (CMG) 1 Wheel Speed (rpm)", class: "ADCO pui" },
  "Z1000010": { title: "CMG 2 RPM", desc: "Control Moment Gyroscope (CMG) 2 Wheel Speed (rpm)", class: "ADCO pui" },
  "Z1000011": { title: "CMG 3 RPM", desc: "Control Moment Gyroscope (CMG) 3 Wheel Speed (rpm)", class: "ADCO pui" },
  "Z1000012": { title: "CMG 4 RPM", desc: "Control Moment Gyroscope (CMG) 4 Wheel Speed (rpm)", class: "ADCO pui" },
  "Z1000013": { title: "KU XMIT", desc: "Ku-Band Transmit", class: "CATO pui" },
  "Z1000014": { title: "SGANT EL", desc: "Ku-Band SGANT Elevation Position", class: "CATO pui" },
  "Z1000015": { title: "SGANT XEL", desc: "Ku-Band SGANT Cross-Elevation Position", class: "CATO pui" },
  "CSAMT000001": { title: "MT POS", desc: "MSS MT Position Float", class: "CSA pui" },
  "CSAMT000002": { title: "MT WORKSITE", desc: "MSS MT Utility Port ID (which Worksite MT is connected to, WS1 though WS8)", class: "CSA pui" },
  "CSASSRMS001-1": { title: "SACS BASE", desc: "MSS EDCD SACS Operating Base", class: "CSA pui" },
  "CSASSRMS002": { title: "SSRMS BASE LOC", desc: "MSS EDCD SSRMS Base Location", class: "CSA pui" },
  "CSASSRMS003": { title: "SSRMS OPER BASE", desc: "MSS EDCD SSRMS Operating Base (Which LEE is Base)", class: "CSA pui" },
  "CSASSRMS004": { title: "SSRMS SR POS", desc: "SSRMS SR Measured Joint Position", class: "CSA pui" },
  "CSASSRMS005": { title: "SSRMS SY POS", desc: "SSRMS SY Measured Joint Position", class: "CSA pui" },
  "CSASSRMS006": { title: "SSRMS SP POS", desc: "SSRMS SP Measured Joint Position", class: "CSA pui" },
  "CSASSRMS007": { title: "SSRMS EP POS", desc: "SSRMS EP Measured Joint Position", class: "CSA pui" },
  "CSASSRMS008": { title: "SSRMS WP POS", desc: "SSRMS WP Measured Joint Position", class: "CSA pui" },
  "CSASSRMS009": { title: "SSRMS WY POS", desc: "SSRMS WY Measured Joint Position", class: "CSA pui" },
  "CSASSRMS010": { title: "SSRMS WR POS", desc: "SSRMS WR Measured Joint Position", class: "CSA pui" },
  "CSASSRMS011": { title: "SSRMS TIP LEE STAT", desc: "MSS OCS Payload Status SSRMS Tip LEE", class: "CSA pui" },
  "CSASPDM0001-1": { title: "SPDM BASE", desc: "SPDM Operating Base", class: "CSA pui" },
  "CSASPDM0002": { title: "SPDM BASE LOC", desc: "MSS OCS Base Location SPDM", class: "CSA pui" },
  "CSASPDM0003": { title: "SPDM 1 SR POS", desc: "MSS OCS SPDM 1 SR Measured Joint Position", class: "CSA pui" },
  "CSASPDM0004": { title: "SPDM 1 SY POS", desc: "MSS OCS SPDM 1 SY Measured Joint Position", class: "CSA pui" },
  "CSASPDM0005": { title: "SPDM 1 SP POS", desc: "MSS OCS SPDM 1 SP Measured Joint Position", class: "CSA pui" },
  "CSASPDM0006": { title: "SPDM 1 EP POS", desc: "MSS OCS SPDM 1 EP Measured Joint Position", class: "CSA pui" },
  "CSASPDM0007": { title: "SPDM 1 WP POS", desc: "MSS OCS SPDM 1 WP Measured Joint Position", class: "CSA pui" },
  "CSASPDM0008": { title: "SPDM 1 WY POS", desc: "MSS OCS SPDM 1 WY Measured Joint Position", class: "CSA pui" },
  "CSASPDM0009": { title: "SPDM 1 WR POS", desc: "MSS OCS SPDM 1 WR Measured Joint Position", class: "CSA pui" },
  "CSASPDM0010": { title: "SPDM 1 OTCM STAT", desc: "MSS Payload Status OCS SPDM Arm 1 OTCM", class: "CSA pui" },
  "CSASPDM0011": { title: "SPDM 2 SR POS", desc: "MSS OCS SPDM 2 SR Measured Joint Position", class: "CSA pui" },
  "CSASPDM0012": { title: "SPDM 2 SY POS", desc: "MSS OCS SPDM 2 SY Measured Joint Position", class: "CSA pui" },
  "CSASPDM0013": { title: "SPDM 2 SP POS", desc: "MSS OCS SPDM 2 SP Measured Joint Position", class: "CSA pui" },
  "CSASPDM0014": { title: "SPDM 2 EP POS", desc: "MSS OCS SPDM 2 EP Measured Joint Position", class: "CSA pui" },
  "CSASPDM0015": { title: "SPDM 2 WP POS", desc: "MSS OCS SPDM 2 WP Measured Joint Position", class: "CSA pui" },
  "CSASPDM0016": { title: "SPDM 2 WY POS", desc: "MSS OCS SPDM 2 WY Measured Joint Position", class: "CSA pui" },
  "CSASPDM0017": { title: "SPDM 2 WR POS", desc: "MSS OCS SPDM 2 WR Measured Joint Position", class: "CSA pui" },
  "CSASPDM0018-1": { title: "SPDM 1 HOT", desc: "MSS SPDM Arm 1 Hot", class: "CSA pui" },
  "CSASPDM0018-2": { title: "SPDM 2 HOT", desc: "MSS SPDM Arm 2 Hot", class: "CSA pui" },
  "CSASPDM0019": { title: "SPDM 2 OTCM STAT", desc: "MSS Payload Status OCS SPDM Arm 2 OTCM", class: "CSA pui" },
  "CSASPDM0020": { title: "SPDM BR POS", desc: "MSS OCS SPDM Body Roll Joint Position", class: "CSA pui" },
  "CSASPDM0021-1": { title: "SPDM LEE STP CND", desc: "SPDM Lee Stop Condition", class: "CSA pui" },
  "CSASPDM0021-2": { title: "SPDM LEE RUN SPD", desc: "SPDM Lee Run Speed", class: "CSA pui" },
  "CSASPDM0021-3": { title: "SPDM LEE HOT", desc: "SPDM Lee Hot", class: "CSA pui" },
  "CSASPDM0022": { title: "SPDM BODY PL STAT", desc: "MSS Payload Status OCS SPDM Body", class: "CSA pui" },
  "CSAMBS00001-1": { title: "MBS OPER BASE", desc: "MBS Operating Base", class: "CSA pui" },
  "CSAMBS00001-2": { title: "MBS BASE LOC", desc: "MBS Base Location", class: "CSA pui" },
  "CSAMBS00002": { title: "MCAS PL STATUS", desc: "MSS OCS Payload Status MBS MCAS", class: "CSA pui" },
  "CSAMBA00003-1": { title: "MBS POA STP CND", desc: "POA Stop Condition", class: "CSA pui" },
  "CSAMBA00003-2": { title: "MBS POA LEE SPD", desc: "POA LEE Speed", class: "CSA pui" },
  "CSAMBA00003-3": { title: "MBS POA HOT", desc: "POA Hot", class: "CSA pui" },
  "CSAMBA00003-4": { title: "SSRMS LEE STP", desc: "SSRMS LEE Stop Condition", class: "CSA pui" },
  "CSAMBA00003-5": { title: "SSRMS LEE SPD", desc: "POA LEE Speed", class: "CSA pui" },
  "CSAMBA00003-6": { title: "SSRMS LEE HOT", desc: "POA Hot", class: "CSA pui" },
  "CSAMBA00004": { title: "POA PL STATUS", desc: "MSS OCS Payload Status MBS POA", class: "CSA pui" },
  "TIME_000001": { title: "Signal Status", desc: "ISS Telemetry Connection Status", class: "" }
};

const VALUE_TO_STRING: { [key: string]: { [key: number]: string } } = {
  "AIRLOCK000019": { 0: "NORMAL", 1: "NO DATA", 2: "MISSING DATA", 3: "EXTRA DATA" },
  "AIRLOCK000020": { 0: "NORMAL", 1: "NO DATA", 2: "MISSING DATA", 3: "EXTRA DATA" },
  "AIRLOCK000021": { 0: "NORMAL", 1: "NO DATA", 2: "MISSING DATA", 3: "EXTRA DATA" },
  "AIRLOCK000022": { 0: "NORMAL", 1: "NO DATA", 2: "MISSING DATA", 3: "EXTRA DATA" },
  "AIRLOCK000023": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000024": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000025": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000026": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000027": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000028": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000029": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000030": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000031": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000032": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000033": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000034": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000035": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000036": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000037": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000038": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000039": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000040": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000041": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000042": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000043": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000044": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000045": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000046": {
    0: "NO HISTORY",
    1: "CHARGING",
    2: "TASK COMPLETE",
    3: "STOP SWITCH",
    4: "OPEN CIRCUIT",
    5: "WRONG BATT",
    6: "OVERTEMP",
    7: "CAPACITY TEST OK",
    8: "CAPACITY TEST ERROR",
    9: "LOW CHARGE SLOPE",
    10: "POWER ERROR",
    11: "REVERSE-POLARITY",
    12: "SHORT-CIRCUIT",
    13: "TIME-OUT",
    14: "EXT TEMP ERROR",
    15: "DISCHARGE",
    16: "WAIT DISCHARGE",
    17: "WAIT CHARGE"
  },
  "AIRLOCK000047": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "AIRLOCK000048": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "AIRLOCK000050": { 0: "CLOSED", 1: "OPEN", 2: "IN-TRANSIT", 3: "FAILED" },
  "AIRLOCK000051": { 0: "CLOSED", 1: "OPEN", 2: "IN-TRANSIT", 3: "FAILED" },
  "AIRLOCK000052": { 0: "CLOSED", 1: "OPEN", 2: "IN-TRANSIT", 3: "FAILED" },
  "AIRLOCK000053": { 0: "RESET", 1: "DRAIN", 2: "DRYOUT", 3: "EIB OFF", 4: "OFF", 5: "ON", 6: "STARTUP", 7: "TEST" },
  "AIRLOCK000058": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE1000001": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE1000002": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE2000003": { 0: "RESET", 1: "DRAIN", 2: "DRYOUT", 3: "EIB OFF", 4: "OFF", 5: "ON", 6: "STARTUP", 7: "TEST" },
  "NODE2000004": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE2000005": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE3000004": { 2: "STOP", 4: "SHUTDOWN", 8: "MAINTENANCE", 16: "NORMAL", 32: "STANDBY", 64: "IDLE", 128: "SYSTEM INITIALIZED" },
  "NODE3000006": { 1: "STOP", 2: "SHUTDOWN", 3: "STANDBY", 4: "PROCESS", 5: "HOT SERVICE", 6: "FLUSH", 7: "WARM SHUTDOWN" },
  "NODE3000007": { 0: "NONE", 1: "VENT", 2: "HEATUP", 3: "PURGE", 4: "FLOW", 5: "TEST", 6: "TEST_SV_1", 7: "TEST_SV_2", 8: "SERVICE" },
  "NODE3000010": { 1: "PROCESS", 2: "STANDBY", 3: "SHUTDOWN", 4: "STOP", 5: "VENT_DOME", 6: "INERT_DOME", 7: "FAST_SHUTDOWN", 8: "N2_PURGE_SHUTDOWN" },
  "NODE3000014": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE3000015": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE3000016": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "NODE3000018": { 0: "RESET", 1: "DRAIN", 2: "DRYOUT", 3: "EIB OFF", 4: "OFF", 5: "ON", 6: "STARTUP", 7: "TEST" },
  "NODE3000020": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "P1000006": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "P1000007": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "P1000008": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "P1000009": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "P3000001": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "P3000002": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "P4000003": { 0: "NOT ENABLED", 1: "ENABLED" },
  "P4000006": { 0: "NOT ENABLED", 1: "ENABLED" },
  "P6000003": { 0: "NOT ENABLED", 1: "ENABLED" },
  "P6000006": { 0: "NOT ENABLED", 1: "ENABLED" },
  "RUSSEG000001": { 1: "CREW RESCUE", 2: "SURVIVAL", 3: "REBOOST", 4: "PROXIMITY OPERATIONS", 5: "EVA", 6: "MICROGRAVITY", 7: "STANDARD" },
  "RUSSEG000002": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000003": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000004": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000007": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000008": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000009": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000010": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000011": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000012": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000013": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000014": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000015": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000016": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000017": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000018": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000019": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000020": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000021": { 0: "INERTIAL", 1: "LVLH SM", 2: "SOLAR", 3: "CURRENT LVLH", 4: "CURRENT INERTIAL", 5: "DAMPING", 6: "TEA", 7: "X-POP" },
  "RUSSEG000022": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000023": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000024": { 0: "-", 1: "XXXXXXXX" },
  "RUSSEG000025": { 0: "RESERVED", 1: "THRUSTERS", 2: "GYRODINES", 3: "GYRO AMER DESAT", 4: "GYRO RUS DESAT", 5: "XLAT THRUST", 6: "CMG/THRUST ASST", 7: "FREE DRIFT" },
  "S0000006": { 1: "STANDBY", 2: "RESTART", 3: "CHECKOUT", 4: "DIRECTED POSITION", 5: "AUTOTRACK", 6: "BLIND", 7: "SHUTDOWN", 8: "SWITCHOVER" },
  "S0000007": { 1: "STANDBY", 2: "RESTART", 3: "CHECKOUT", 4: "DIRECTED POSITION", 5: "AUTOTRACK", 6: "BLIND", 7: "SHUTDOWN", 8: "SWITCHOVER" },
  "S0000008": { 1: "STANDBY", 2: "RESTART", 3: "CHECKOUT", 4: "DIRECTED POSITION", 5: "AUTOTRACK", 6: "BLIND", 7: "SHUTDOWN", 8: "SWITCHOVER" },
  "S0000009": { 1: "STANDBY", 2: "RESTART", 3: "CHECKOUT", 4: "DIRECTED POSITION", 5: "AUTOTRACK", 6: "BLIND", 7: "SHUTDOWN", 8: "SWITCHOVER" },
  "S0000010": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S0000011": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S0000012": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S0000013": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S1000006": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S1000007": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S1000008": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S1000009": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S3000001": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S3000002": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "S4000003": { 0: "NOT ENABLED", 1: "ENABLED" },
  "S4000006": { 0: "NOT ENABLED", 1: "ENABLED" },
  "S6000003": { 0: "NOT ENABLED", 1: "ENABLED" },
  "S6000006": { 0: "NOT ENABLED", 1: "ENABLED" },
  "USLAB000001": { 0: "NOT IN USE", 1: "IN USE" },
  "USLAB000002": { 0: "NOT IN USE", 1: "IN USE" },
  "USLAB000003": { 0: "NOT IN USE", 1: "IN USE" },
  "USLAB000004": { 0: "NOT IN USE", 1: "IN USE" },
  "USLAB000011": { 0: "ENABLED", 1: "INHIBITED" },
  "USLAB000012": { 0: "Default", 1: "WAIT", 2: "RESERVED", 3: "STANDBY", 4: "CMG ATT CTRL", 5: "CMG/THRUST ASST", 6: "USER DATA GEN", 7: "FREE DRIFT" },
  "USLAB000013": { 0: "NONE", 1: "GPS1", 2: "GPS2", 3: "RUSSIAN ATT", 4: "KU BAND" },
  "USLAB000014": { 0: "NONE", 1: "RGA1", 2: "RGA2", 3: "RUSSIAN" },
  "USLAB000015": { 0: "NO_SOURCE", 1: "UNUSED", 2: "UNUSED", 3: "RUSSIAN", 4: "GPS1_DETERMINISTIC", 5: "GPS2_DETERMINISTIC", 6: "GROUND" },
  "USLAB000016": { 0: "ATTITUDE HOLD", 1: "TEA" },
  "USLAB000017": { 0: "LVLH", 1: "Inertial", 2: "XPOP" },
  "USLAB000041": { 0: "FALSE", 1: "TRUE" },
  "USLAB000042": { 0: "FALSE", 1: "TRUE" },
  "USLAB000043": { 0: "DOING POS FIXES", 1: "SV TIMING", 2: "APRX TIMING", 3: "GPS TIME", 4: "NEED INIT", 5: "GDOP NEEDED", 6: "BAD TIMING", 7: "NO USABLE SV", 8: "ONLY 1 USABLE SVs", 9: "ONLY 2 USABLE SVs", 10: "ONLY 3 USABLE SVs", 11: "BAD INTEGRITY", 12: "NO VEL AVAIL", 13: "UNUSABLE FIX" },
  "USLAB000044": { 0: "DOING POS FIXES", 1: "SV TIMING", 2: "APRX TIMING", 3: "GPS TIME", 4: "NEED INIT", 5: "GDOP NEEDED", 6: "BAD TIMING", 7: "NO USABLE SV", 8: "ONLY 1 USABLE SVs", 9: "ONLY 2 USABLE SVs", 10: "ONLY 3 USABLE SVs", 11: "BAD INTEGRITY", 12: "NO VEL AVAIL", 13: "UNUSABLE FIX" },
  "USLAB000062": { 0: "FAIL", 1: "OPEN", 2: "CLSD", 3: "TRNS" },
  "USLAB000063": { 0: "FAIL", 1: "OPEN", 2: "CLSD", 3: "TRNS" },
  "USLAB000064": { 0: "RESET", 1: "DRAIN", 2: "DRYOUT", 3: "EIB OFF", 4: "OFF", 5: "ON", 6: "STARTUP", 7: "TEST" },
  "USLAB000065": { 0: "RESET", 1: "DRAIN", 2: "DRYOUT", 3: "EIB OFF", 4: "OFF", 5: "ON", 6: "STARTUP", 7: "TEST" },
  "USLAB000066": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000067": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000068": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000069": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000070": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000071": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000072": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000073": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000074": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000075": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000076": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000077": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000078": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000079": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000080": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000081": { 0: "FALSE", 1: "TRUE" },
  "USLAB000086": { 1: "STANDARD", 2: "MICROGRAVITY", 4: "REBOOST", 8: "PROXIMITY_OPS", 16: "EXTERNAL_OPS", 32: "SURVIVAL", 64: "ASCR", 127: "ALL_MODES" },
  "USLAB000088": { 0: "INACTIVE", 1: "ACTIVE" },
  "USLAB000089": { 0: "INACTIVE", 1: "ACTIVE" },
  "USLAB000090": { 0: "INACTIVE", 1: "ACTIVE" },
  "USLAB000091": { 0: "INACTIVE", 1: "ACTIVE" },
  "USLAB000092": { 1: "STRING 1", 2: "STRING 2" },
  "USLAB000093": { 0: "BACKUP", 1: "ACTIVE" },
  "USLAB000094": { 0: "BACKUP", 1: "ACTIVE" },
  "USLAB000095": { 0: " -", 1: "S3AFT", 2: "S1UPOB", 3: "SCU1 MUX", 4: "S1LOOB", 5: "JPM A", 6: "JPM B", 7: "S1UPIB", 8: "S1LOIB", 9: "COL 1", 10: "COL 2", 11: "P1UPIB", 12: "SCU2 MUX", 13: "NOD3S", 14: "P1LOIB", 15: "SCU1 TEST", 16: "WETA112", 17: "ORB1", 18: "ORB2", 19: "P1LOOB", 20: "SCU2 TEST", 21: "P3AFT", 22: "PAYLOAD RACK", 23: "VTR1", 24: "VTR2", 25: "NOD2LO", 26: "WETA115", 28: "LAB S", 31: "POA PL3", 32: "POA", 33: "SPDMS1", 34: "SPDMS2", 35: "MBS CLPA", 36: "SPDMLEE", 37: "MAST", 40: "BLEE", 43: "BELB", 48: "TELB", 50: "MSS PL3", 51: "TLEE", 52: "LAB AVU1", 53: "LAB AVU2", 54: "CUP AVU1", 55: "CUP AVU2", 56: "OTCM1", 57: "BODY1", 58: "OTCM2", 59: "BODY2", 60: "SSRMS PL1", 61: "SSRMS PL2", 62: "SSRMS PL3", 63: "MSS PL1", 64: "MSS PL2", 65: "LAB1D3", 66: "LAB1P2", 67: "LAB1P4", 68: "LABCAM", 69: "LAB1O5", 70: "LAB1O4", 71: "LAB1O3", 72: "LAB1O2", 73: "LAB1O1", 74: "LAB1S1", 75: "LAB1S2", 76: "LAB1S3", 77: "A/L CAM", 78: "LAB1S4", 79: "N1 CAM", 80: "N3 CAM" },
  "USLAB000096": { 0: " -", 1: "S3AFT", 2: "S1UPOB", 3: "SCU1 MUX", 4: "S1LOOB", 5: "JPM A", 6: "JPM B", 7: "S1UPIB", 8: "S1LOIB", 9: "COL 1", 10: "COL 2", 11: "P1UPIB", 12: "SCU2 MUX", 13: "NOD3S", 14: "P1LOIB", 15: "SCU1 TEST", 16: "WETA112", 17: "ORB1", 18: "ORB2", 19: "P1LOOB", 20: "SCU2 TEST", 21: "P3AFT", 22: "PAYLOAD RACK", 23: "VTR1", 24: "VTR2", 25: "NOD2LO", 26: "WETA115", 28: "LAB S", 31: "POA PL3", 32: "POA", 33: "SPDMS1", 34: "SPDMS2", 35: "MBS CLPA", 36: "SPDMLEE", 37: "MAST", 40: "BLEE", 43: "BELB", 48: "TELB", 50: "MSS PL3", 51: "TLEE", 52: "LAB AVU1", 53: "LAB AVU2", 54: "CUP AVU1", 55: "CUP AVU2", 56: "OTCM1", 57: "BODY1", 58: "OTCM2", 59: "BODY2", 60: "SSRMS PL1", 61: "SSRMS PL2", 62: "SSRMS PL3", 63: "MSS PL1", 64: "MSS PL2", 65: "LAB1D3", 66: "LAB1P2", 67: "LAB1P4", 68: "LABCAM", 69: "LAB1O5", 70: "LAB1O4", 71: "LAB1O3", 72: "LAB1O2", 73: "LAB1O1", 74: "LAB1S1", 75: "LAB1S2", 76: "LAB1S3", 77: "A/L CAM", 78: "LAB1S4", 79: "N1 CAM", 80: "N3 CAM" },
  "USLAB000097": { 0: " -", 1: "S3AFT", 2: "S1UPOB", 3: "SCU1 MUX", 4: "S1LOOB", 5: "JPM A", 6: "JPM B", 7: "S1UPIB", 8: "S1LOIB", 9: "COL 1", 10: "COL 2", 11: "P1UPIB", 12: "SCU2 MUX", 13: "NOD3S", 14: "P1LOIB", 15: "SCU1 TEST", 16: "WETA112", 17: "ORB1", 18: "ORB2", 19: "P1LOOB", 20: "SCU2 TEST", 21: "P3AFT", 22: "PAYLOAD RACK", 23: "VTR1", 24: "VTR2", 25: "NOD2LO", 26: "WETA115", 28: "LAB S", 31: "POA PL3", 32: "POA", 33: "SPDMS1", 34: "SPDMS2", 35: "MBS CLPA", 36: "SPDMLEE", 37: "MAST", 40: "BLEE", 43: "BELB", 48: "TELB", 50: "MSS PL3", 51: "TLEE", 52: "LAB AVU1", 53: "LAB AVU2", 54: "CUP AVU1", 55: "CUP AVU2", 56: "OTCM1", 57: "BODY1", 58: "OTCM2", 59: "BODY2", 60: "SSRMS PL1", 61: "SSRMS PL2", 62: "SSRMS PL3", 63: "MSS PL1", 64: "MSS PL2", 65: "LAB1D3", 66: "LAB1P2", 67: "LAB1P4", 68: "LABCAM", 69: "LAB1O5", 70: "LAB1O4", 71: "LAB1O3", 72: "LAB1O2", 73: "LAB1O1", 74: "LAB1S1", 75: "LAB1S2", 76: "LAB1S3", 77: "A/L CAM", 78: "LAB1S4", 79: "N1 CAM", 80: "N3 CAM" },
  "USLAB000098": { 0: " -", 1: "S3AFT", 2: "S1UPOB", 3: "SCU1 MUX", 4: "S1LOOB", 5: "JPM A", 6: "JPM B", 7: "S1UPIB", 8: "S1LOIB", 9: "COL 1", 10: "COL 2", 11: "P1UPIB", 12: "SCU2 MUX", 13: "NOD3S", 14: "P1LOIB", 15: "SCU1 TEST", 16: "WETA112", 17: "ORB1", 18: "ORB2", 19: "P1LOOB", 20: "SCU2 TEST", 21: "P3AFT", 22: "PAYLOAD RACK", 23: "VTR1", 24: "VTR2", 25: "NOD2LO", 26: "WETA115", 28: "LAB S", 31: "POA PL3", 32: "POA", 33: "SPDMS1", 34: "SPDMS2", 35: "MBS CLPA", 36: "SPDMLEE", 37: "MAST", 40: "BLEE", 43: "BELB", 48: "TELB", 50: "MSS PL3", 51: "TLEE", 52: "LAB AVU1", 53: "LAB AVU2", 54: "CUP AVU1", 55: "CUP AVU2", 56: "OTCM1", 57: "BODY1", 58: "OTCM2", 59: "BODY2", 60: "SSRMS PL1", 61: "SSRMS PL2", 62: "SSRMS PL3", 63: "MSS PL1", 64: "MSS PL2", 65: "LAB1D3", 66: "LAB1P2", 67: "LAB1P4", 68: "LABCAM", 69: "LAB1O5", 70: "LAB1O4", 71: "LAB1O3", 72: "LAB1O2", 73: "LAB1O1", 74: "LAB1S1", 75: "LAB1S2", 76: "LAB1S3", 77: "A/L CAM", 78: "LAB1S4", 79: "N1 CAM", 80: "N3 CAM" },
  "USLAB000099": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000100": { 0: "OFF-OK", 1: "NOT-OFF OK", 3: "NOT-OFF FAILED" },
  "USLAB000101": { 0: "UNLOCKED", 1: "LOCKED" },
  "Z1000013": { 0: "RESET", 1: "NORMAL" },
  "CSAMT000002": { 1: "WS1 ", 2: "WS2 ", 3: "WS3 ", 4: "WS4 ", 5: "WS5 ", 6: "WS6 ", 7: "WS7 ", 8: "WS8" },
  "CSASSRMS002": { 1: "LAB ", 2: "NODE3 ", 4: "NODE2 ", 7: "MBS PDGF 1 ", 8: "MBS PDGF 2 ", 11: "MBS PDGF 3 ", 13: "MBS PDGF 4 ", 14: "FGB ", 16: "POA ", 19: "SSRMS TIP LEE ", 63: "UNDEFINED" },
  "CSASSRMS003": { 0: "LEE A ", 5: "LEE B" },
  "CSASSRMS011": { 0: "RELEASED", 1: "CAPTIVE", 2: "CAPTURED" },
  "CSASPDM0002": { 1: "LAB ", 2: "NODE3 ", 4: "NODE2 ", 7: "MBS PDGF 1 ", 8: "MBS PDGF 2 ", 11: "MBS PDGF 3 ", 13: "MBS PDGF 4 ", 14: "FGB ", 16: "POA ", 19: "SSRMS TIP LEE ", 63: "UNDEFINED" },
  "CSASPDM0010": { 0: "RELEASED", 1: "CAPTIVE", 2: "CAPTURED" },
  "CSASPDM0019": { 0: "RELEASED", 1: "CAPTIVE", 2: "CAPTURED" },
  "CSASPDM0022": { 0: "RELEASED", 1: "CAPTIVE", 2: "CAPTURED" },
  "CSAMBS00002": { 0: "RELEASED", 1: "CAPTURED" },
  "CSAMBA00004": { 0: "RELEASED", 1: "CAPTIVE", 2: "CAPTURED" }
};

const VALUE_CONV_FUNC: { [key: string]: (value: TelemetryEntryValueInterface) => TelemetryEntryValueInterface } = {
  "USLAB000084": (value: TelemetryEntryValueInterface) => {
    if (typeof value.value === "number") {
      return {
        value: new Date((new Date(1980, 0, 6, 1, 0, 0, 0)).getTime() + (value.value * 1000)),
        type: "date"
      }
    } else {
      return value
    }
  },
  "TIME_000001": (value: TelemetryEntryValueInterface) => {
    return {
      value: value.value === 24 ? `Signal acquired` : `Signal lost (${value.value})`,
      type: "string"
    }
  }
}

const MULTIPLE_VALUES_SEPERATOR: { [key: string]: (value: number) => Array<{ [key: string]: number }> } = {
  CSASSRMS001: function (value) {
    return new Array<{ [key: string]: number }>(
      { "CSASSRMS001-1": (value >>> 6) & 15 }
    );
  },
  CSASPDM0001: function (value) {
    return new Array<{ [key: string]: number }>(
      { "CSASPDM0001-1": (value >>> 8) & 15 }
    );
  },
  CSASPDM0018: function (value) {
    return new Array<{ [key: string]: number }>(
      { "CSASPDM0018-1": (value >>> 3) & 1 },
      { "CSASPDM0018-2": (value >>> 11) & 1 },
    );
  },
  CSASPDM0021: function (value) {
    return new Array<{ [key: string]: number }>(
      { "CSASPDM0021-1": (value >>> 3) & 1 },
      { "CSASPDM0021-2": (value >>> 4) & 3 },
      { "CSASPDM0021-3": (value >>> 6) & 3 },
    );
  },
  CSAMBS00001: function (value) {
    return new Array<{ [key: string]: number }>(
      { "CSAMBS00001-1": (value >>> 8) & 15 },
      { "CSAMBS00001-2": value & 63 },
    );
  },
  CSAMBA00003: function (value) {
    return new Array<{ [key: string]: number }>(
      { "CSAMBA00003-1": value >>> 14 },
      { "CSAMBA00003-2": (value >>> 12) & 3 },
      { "CSAMBA00003-3": (value >>> 11) & 1 },
      { "CSAMBA00003-4": (value >>> 6) & 3 },
      { "CSAMBA00003-5": (value >>> 4) & 3 },
      { "CSAMBA00003-6": (value >>> 3) & 1 },
    );
  }
};
